module.exports = __webpack_public_path__ + "static/media/monopoly card - 1.28802036.PNG";